import React from 'react';
import styled, { css } from 'styled-components';

type ModalPosition = 'center' | 'right-bottom'

interface IModalProps {
  children: React.ReactNode;
  position?: ModalPosition;
}


export default function Modal({
  children,
  position = 'center'
}: IModalProps){
  return <Container $position={position}>{children}</Container>
}

const Container = styled.div<{$position: ModalPosition}>`
  position: fixed;
  display: flex;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: var(--color-bg-modal);
  padding: 40px;
  z-index: 1000;
  overflow-y: scroll;

  ${p => p.$position === 'center' && css`
    align-items: center !important;
    justify-content: center !important;

    padding: 40px 20px;
    align-items: flex-start !important;
  `}

  ${p => p.$position === 'right-bottom' && css`
    align-items: flex-end !important;
    justify-content: flex-end !important;
  `}

  @media (max-width: 480px) {
    padding: 40px 20px;
    height: 100%;
    align-items: flex-start !important;
    justify-content: flex-start !important;
  }
`
